export function formatTime(date: Date) {
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;

  const formattedTime = `${hours ? hours : 12}:${minutes < 10 ? '0' + minutes : minutes}${ampm}`;
  return formattedTime;
}
